const API_KEY = 'AIzaSyACeL0ltu60rAtGGegL7p0iaUki_RKM30k';

if (document.getElementById('js-rlx-map') !== null
  && !mapsExists()
) {
  initMaps();
}

/**
 * Check if the Google Maps API has been loaded
 * @returns {boolean} If the Google Maps API has been loaded or not
 */
function mapsExists() {
  if (
    typeof window.google === 'undefined'
  ) {
    return false;
  } else {
    return true;
  }
}

/**
 * Add the Google Maps script tag and loads the API
 * @returns The maps API (window.google.maps)
 */
function loadApi() {
  return new Promise((resolve, reject) => {
    if (!mapsExists()) {
      const script = document.createElement('script');

      script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=Function.prototype`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        resolve(window.google.maps);
      };

      script.onerror = reject;
      script.onabort = reject;

      document.head.appendChild(script);
    } else {
      resolve(window.google.maps);
    }
  });
}

async function initMaps() {
  let mapsApi;
  try {
    mapsApi = await loadApi();
  } catch (err) {
    throw new Error('Could not load Google Maps API');
  }

  // ---------------
  //  Your maps logic starts here:
  // ---------

  // let maps = document.querySelectorAll('.js-map');

  let map = document.getElementById('js-rlx-map');

  // let map;

  // let infoWindows = [];

  initMap(map);

  // maps.forEach((map) => {
  //   initMap(map);
  // });

  function initMap(location) {
    // const SnazzyInfoWindow = require('snazzy-info-window')
    const lng = Number(location.getAttribute('data-lng'));
    const lat = Number(location.getAttribute('data-lat'));

    let mapOptions = {
      zoom: 16,
      center: { lat: lat, lng: lng },
      mapTypeId: 'roadmap',
      disableDefaultUI: true,
      zoomControl: false,
      styles: [
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#e9e9e9' }, { lightness: 17 }],
        },
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }, { lightness: 20 }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [{ color: '#ffffff' }, { lightness: 17 }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }, { lightness: 18 }],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }, { lightness: 16 }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#dedede' }, { lightness: 21 }],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            { visibility: 'on' },
            { color: '#ffffff' },
            { lightness: 16 },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            { saturation: 36 },
            { color: '#333333' },
            { lightness: 40 },
          ],
        },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        {
          featureType: 'transit',
          elementType: 'geometry',
          stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.fill',
          stylers: [{ color: '#fefefe' }, { lightness: 20 }],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry.stroke',
          stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }],
        },
      ],
    };

    map = new mapsApi.Map(location, mapOptions);

    let latLng = new google.maps.LatLng(lat, lng);
    // Creating the actual marker and putting it on the map

    new google.maps.Marker({
      position: latLng,
      // @ts-ignore
      title: name,
      // @ts-ignore
      map: map,
      icon: {
        url: '/img/rolex-v6/marker.png',
        size: new google.maps.Size(51, 60),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(12, 30),
      },
    });
  }
}
